module.exports = __webpack_public_path__ + "img/golic.c224649c.png";